import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SettingsState } from "./settings.state";
import { getSettings } from "./settings.thunk";
import { Settings } from "./settings.types";

const initialState: SettingsState = {
  data: null,
  status: "idle",
  error: null,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    resetSettings: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
    setSettings: (state, action: PayloadAction<Settings>) => {
      state.data = action.payload;
      state.status = "success";
    },
  },
  extraReducers: (build) => {
    build
      .addCase(getSettings.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getSettings.fulfilled,
        (state, action: PayloadAction<Settings>) => {
          state.status = "success";
          state.data = action.payload;
        },
      )
      .addCase(
        getSettings.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Ayarlar yüklenemedi.";
        },
      );
  },
});

export const { resetSettings, setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
